export default __webpack_public_path__ + "static/media/Group756.a9e22691.svg";